<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M10.7933 1.33325H8.5V5.33325V5.83325V9.16659H14.6667V5.83325V5.33325V5.20659C14.6667 2.77992 13.22 1.33325 10.7933 1.33325Z"
    fill="#5B6673"
  />
  <path
    d="M1.33203 6.83325V10.1666V10.4999V10.7933C1.33203 13.2199 2.7787 14.6666 5.20536 14.6666H7.4987V10.4999V10.1666V6.83325H1.33203Z"
    fill="#5B6673"
  />
  <path
    d="M7.4987 1.33325V5.83325H1.33203V5.20659C1.33203 2.77992 2.7787 1.33325 5.20536 1.33325H7.4987Z"
    fill="#5B6673"
  />
  <path
    d="M14.6667 10.1667V10.7934C14.6667 13.2201 13.22 14.6667 10.7933 14.6667H8.5V10.1667H14.6667Z"
    fill="#5B6673"
  />
</svg>
